import { useLocation } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import Container from '@mui/material/Container';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import CustomHeader from '../../../General/CustomHeader';
import Page from '../../../Layout/Page';
import FullScreenChartShell from '../../FullScreenChartShell/FullScreenChartShell';
import useStyles from '../../styles';
import ChillPortionsChart from './ChillPortionsChart';
import ChillPortionsConfigContent from './ChillPortionsConfigContent';
import { CHILL_PORTIONS_NAME } from '../../../../constants/graphs';
import { ReduxState } from '../../../../types';
import { generateBreadcrumb } from '../../utils';
import { ModalState, EMPTY_MODAL_STATE } from '../../chartModal';

const ChillPortionsConfig = ({ fullScreen }: { fullScreen?: boolean }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const { selectedSector } = useSelector((state: ReduxState) => state.currentSector);

  const [, setModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const [conversationsRefreshCounter] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const farmId = queryParams.get('farmId') || '';
  const sectorId = queryParams.get('sectorId') || '';

  const breadcrumb = useMemo(() => generateBreadcrumb(
    selectedFarm, selectedSector, CHILL_PORTIONS_NAME, sectorId,
  ), [selectedFarm, selectedSector]);

  if (fullScreen) {
    return (
      <FullScreenChartShell title="Porciones de Frío">
        {(h) => (
          <ChillPortionsChart
            chartView="fullScreen"
            sectorId={sectorId}
            farmId={farmId}
            hideXValues={false}
            height={`${h}px`}
            refreshKey={refreshTrigger}
          />
        )}
      </FullScreenChartShell>
    );
  }

  return (
    <Page className={classes.root} title='Configuración gráfico de porciones de frío'>
      <Container maxWidth={false}>
        <CustomHeader title={breadcrumb} />
        <Box mt={3}>
          <ChillPortionsChart
            chartView="settings"
            sectorId={sectorId}
            farmId={farmId}
            refreshKey={refreshTrigger}
          />
        </Box>
        <ChillPortionsConfigContent
          sectorId={sectorId}
          setModalState={setModalState}
          refreshCounter={conversationsRefreshCounter}
          onConfigSaved={() => setRefreshTrigger((prev) => prev + 1)}
        />
      </Container>
    </Page>
  );
};

export default ChillPortionsConfig;
